(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('gbm-hero-slider')) return;

    class GBMHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.gbm-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.gbm-hero__dot'));
        this.track = this.querySelector('.gbm-hero__track');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.timer = null;
        this.pointerStart = null;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.isDesignMode = this.classList.contains('gbm-hero--design-mode');

        this.onPrevious = () => this.show(this.index - 1, true);
        this.onNext = () => this.show(this.index + 1, true);
        this.onKeydown = (event) => {
          if (event.key === 'ArrowLeft') this.onPrevious();
          if (event.key === 'ArrowRight') this.onNext();
        };
        this.onPointerDown = (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          this.pointerStart = { x: event.clientX, y: event.clientY };
        };
        this.onPointerUp = (event) => {
          if (!this.pointerStart) return;
          const x = event.clientX - this.pointerStart.x;
          const y = event.clientY - this.pointerStart.y;
          this.pointerStart = null;
          if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y)) {
            x < 0 ? this.onNext() : this.onPrevious();
          }
        };
        this.onResize = () => {
          window.clearTimeout(this.resizeTimer);
          this.resizeTimer = window.setTimeout(() => this.updateHotspots(), 80);
        };
        this.onBlockSelect = (event) => {
          const selected = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
          if (!selected) return;
          this.stop();
          this.show(Number(selected.dataset.slideIndex), true);
        };

        this.querySelector('.gbm-hero__arrow--previous')?.addEventListener('click', this.onPrevious);
        this.querySelector('.gbm-hero__arrow--next')?.addEventListener('click', this.onNext);
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.slideTarget), true)));
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('pointerdown', this.onPointerDown, { passive: true });
        this.addEventListener('pointerup', this.onPointerUp, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        if (this.dataset.pauseHover === 'true') {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
        }
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        this.slides.forEach((slide) => {
          const image = slide.querySelector('.gbm-hero__image');
          if (image && !image.complete) image.addEventListener('load', () => this.updateHotspot(slide), { once: true });
        });

        this.show(this.index, false);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        window.clearTimeout(this.resizeTimer);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('pointerup', this.onPointerUp);
      }

      show(requestedIndex, userInitiated) {
        if (this.slides.length === 0) return;
        const loop = this.dataset.loop === 'true';
        let nextIndex = requestedIndex;
        if (loop) nextIndex = (nextIndex + this.slides.length) % this.slides.length;
        else nextIndex = Math.min(Math.max(nextIndex, 0), this.slides.length - 1);
        this.index = nextIndex;
        this.track?.style.setProperty('--gbm-active-index', String(nextIndex));

        this.slides.forEach((slide, index) => {
          const active = index === nextIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if ('inert' in slide) slide.inert = !active;
          slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((item) => {
            if (!active) {
              if (!item.hasAttribute('data-gbm-tabindex')) item.setAttribute('data-gbm-tabindex', item.getAttribute('tabindex') ?? '');
              item.setAttribute('tabindex', '-1');
            } else if (item.hasAttribute('data-gbm-tabindex')) {
              const previous = item.getAttribute('data-gbm-tabindex');
              previous ? item.setAttribute('tabindex', previous) : item.removeAttribute('tabindex');
              item.removeAttribute('data-gbm-tabindex');
            }
          });
        });

        this.dots.forEach((dot, index) => {
          const active = index === nextIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        const activeSlide = this.slides[nextIndex];
        this.style.setProperty('--gbm-active-desktop-ratio', activeSlide.dataset.desktopRatio || '2.4');
        this.style.setProperty('--gbm-active-mobile-ratio', activeSlide.dataset.mobileRatio || '0.8');
        requestAnimationFrame(() => this.updateHotspot(activeSlide));

        if (userInitiated) {
          this.stop();
          this.start();
        }
      }

      start() {
        this.stop();
        if (this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.isDesignMode || this.reduceMotion.matches) return;
        const delay = Math.max(3, Number(this.dataset.autoplaySeconds) || 5) * 1000;
        this.timer = window.setInterval(() => this.show(this.index + 1, false), delay);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      updateHotspots() {
        this.slides.forEach((slide) => this.updateHotspot(slide));
      }

      updateHotspot(slide) {
        const frame = slide?.querySelector('.gbm-hero__hotspot-frame');
        const image = slide?.querySelector('.gbm-hero__image');
        if (!frame || !image || !image.naturalWidth || !image.naturalHeight) return;

        const width = slide.clientWidth;
        const height = slide.clientHeight;
        if (!width || !height) return;

        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const posX = Number(mobile ? slide.dataset.mobilePosX : slide.dataset.desktopPosX);
        const posY = Number(mobile ? slide.dataset.mobilePosY : slide.dataset.desktopPosY);
        const imageRatio = image.naturalWidth / image.naturalHeight;
        const containerRatio = width / height;
        const fit = slide.dataset.fit;
        let renderedWidth;
        let renderedHeight;

        if ((fit === 'cover' && imageRatio > containerRatio) || (fit === 'contain' && imageRatio < containerRatio)) {
          renderedHeight = height;
          renderedWidth = height * imageRatio;
        } else {
          renderedWidth = width;
          renderedHeight = width / imageRatio;
        }

        frame.style.left = `${(width - renderedWidth) * posX}px`;
        frame.style.top = `${(height - renderedHeight) * posY}px`;
        frame.style.width = `${renderedWidth}px`;
        frame.style.height = `${renderedHeight}px`;
      }
    }

    customElements.define('gbm-hero-slider', GBMHeroSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
